var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReasign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20V17.5H3.4375L2.9375 17.0625C1.91667 16.0417 1.17208 14.9325 0.70375 13.735C0.235417 12.5375 0.000833333 11.3133 0 10.0625C0 7.75 0.692917 5.69292 2.07875 3.89125C3.46458 2.08958 5.27167 0.896667 7.5 0.3125V2.9375C6 3.47917 4.79167 4.40125 3.875 5.70375C2.95833 7.00625 2.5 8.45917 2.5 10.0625C2.5 11 2.67708 11.9117 3.03125 12.7975C3.38542 13.6833 3.9375 14.5008 4.6875 15.25L5 15.5625V12.5H7.5V20H0ZM12.5 19.6875V17.0625C14 16.5208 15.2083 15.5992 16.125 14.2975C17.0417 12.9958 17.5 11.5425 17.5 9.9375C17.5 9 17.3229 8.08875 16.9688 7.20375C16.6146 6.31875 16.0625 5.50083 15.3125 4.75L15 4.4375V7.5H12.5V0H20V2.5H16.5625L17.0625 2.9375C18.0833 3.95833 18.8283 5.06792 19.2975 6.26625C19.7667 7.46458 20.0008 8.68833 20 9.9375C20 12.25 19.3075 14.3075 17.9225 16.11C16.5375 17.9125 14.73 19.105 12.5 19.6875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReasign);
export default __webpack_public_path__ + "static/media/reasign.c75c5872fb5a9de7583cc2ca9f68f079.svg";
export { ForwardRef as ReactComponent };